const data = [
    {
        id: 1,
        name: "Standard Kart",
        type: "kart",
        img: "StandardKartBodyMK8.png",
        wg: 2,
        ac: 4,
        on: 3,
        of: 3,
        mt: 4,
        sl: 3,
        sw: 3,
        sa: 3,
        sg: 3,
        tl: 3,
        tw: 2,
        ta: 3,
        tg: 3
    },
    {
        id: 2,
        name: "Pipe Frame",
        type: "kart",
        img: "PipeFrameBodyMK8.png",
        wg: 1,
        ac: 6,
        on: 3,
        of: 4,
        mt: 6,
        sl: 1,
        sw: 3,
        sa: 1,
        sg: 1,
        tl: 5,
        tw: 4,
        ta: 4,
        tg: 2
    },
    {
        id: 3,
        name: "Mach 8",
        type: "kart",
        img: "Mach8BodyMK8.png",
        wg: 3,
        ac: 3,
        on: 2,
        of: 4,
        mt: 4,
        sl: 3,
        sw: 3,
        sa: 5,
        sg: 4,
        tl: 2,
        tw: 2,
        ta: 4,
        tg: 2
    },
    {
        id: 4,
        name: "Steel Driver",
        type: "kart",
        img: "Steel_Driver.png",
        wg: 4,
        ac: 1,
        on: 1,
        of: 3,
        mt: 2,
        sl: 4,
        sw: 5,
        sa: 2,
        sg: 0,
        tl: 1,
        tw: 5,
        ta: 1,
        tg: 1
    },
    {
        id: 5,
        name: "Cat Cruiser",
        type: "kart",
        img: "CatCruiserBodyMK8.png",
        wg: 2,
        ac: 5,
        on: 4,
        of: 3,
        mt: 5,
        sl: 2,
        sw: 2,
        sa: 3,
        sg: 4,
        tl: 4,
        tw: 2,
        ta: 3,
        tg: 4
    },
    {
        id: 6,
        name: "Circuit Special",
        type: "kart",
        img: "CircuitSpecialBodyMK8.png",
        wg: 3,
        ac: 1,
        on: 3,
        of: 1,
        mt: 1,
        sl: 5,
        sw: 1,
        sa: 4,
        sg: 2,
        tl: 1,
        tw: 1,
        ta: 2,
        tg: 0
    },
    {
        id: 7,
        name: "Tri-Speeder",
        type: "kart",
        img: "TrispeederBodyMK8.png",
        wg: 4,
        ac: 1,
        on: 1,
        of: 3,
        mt: 2,
        sl: 4,
        sw: 5,
        sa: 2,
        sg: 0,
        tl: 1,
        tw: 5,
        ta: 1,
        tg: 1
    },
    {
        id: 8,
        name: "Badwagon",
        type: "kart",
        img: "BadwagonBodyMK8.png",
        wg: 4,
        ac: 0,
        on: 2,
        of: 5,
        mt: 0,
        sl: 5,
        sw: 2,
        sa: 3,
        sg: 1,
        tl: 0,
        tw: 1,
        ta: 1,
        tg: 0
    },
    {
        id: 9,
        name: "Prancer",
        type: "kart",
        img: "PrancerBodyMK8.png",
        wg: 1,
        ac: 2,
        on: 1,
        of: 2,
        mt: 3,
        sl: 4,
        sw: 3,
        sa: 3,
        sg: 3,
        tl: 3,
        tw: 3,
        ta: 2,
        tg: 3
    },
    {
        id: 10,
        name: "Biddybuggy",
        type: "kart",
        img: "BiddybuggyBodyMK8.png",
        wg: 0,
        ac: 7,
        on: 1,
        of: 4,
        mt: 7,
        sl: 0,
        sw: 1,
        sa: 2,
        sg: 1,
        tl: 5,
        tw: 4,
        ta: 5,
        tg: 4
    },
    {
        id: 11,
        name: "Landship",
        type: "kart",
        img: "LandshipBodyMK8.png",
        wg: 0,
        ac: 6,
        on: 0,
        of: 6,
        mt: 6,
        sl: 1,
        sw: 5,
        sa: 0,
        sg: 2,
        tl: 4,
        tw: 5,
        ta: 2,
        tg: 3
    },
    {
        id: 12,
        name: "Sneeker",
        type: "kart",
        img: "SneakerBodyMK8.png",
        wg: 2,
        ac: 2,
        on: 1,
        of: 0,
        mt: 3,
        sl: 4,
        sw: 2,
        sa: 3,
        sg: 3,
        tl: 3,
        tw: 2,
        ta: 3,
        tg: 2
    },
    {
        id: 13,
        name: "Sports Coupe",
        type: "kart",
        img: "SportsCoupeMK8.png",
        wg: 3,
        ac: 3,
        on: 2,
        of: 4,
        mt: 4,
        sl: 3,
        sw: 3,
        sa: 5,
        sg: 4,
        tl: 2,
        tw: 2,
        ta: 4,
        tg: 2
    },
    {
        id: 14,
        name: "Gold Standard",
        type: "kart",
        img: "Gold_Standard.png",
        wg: 2,
        ac: 2,
        on: 1,
        of: 0,
        mt: 3,
        sl: 4,
        sw: 2,
        sa: 3,
        sg: 3,
        tl: 3,
        tw: 2,
        ta: 3,
        tg: 2
    },
    {
        id: 15,
        name: "Standard Bike",
        type: "kart",
        img: "StandardBikeBodyMK8.png",
        wg: 1,
        ac: 5,
        on: 3,
        of: 5,
        mt: 5,
        sl: 2,
        sw: 2,
        sa: 4,
        sg: 3,
        tl: 4,
        tw: 3,
        ta: 4,
        tg: 3
    },
    {
        id: 16,
        name: "Comet",
        type: "kart",
        img: "CometBodyMK8.png",
        wg: 2,
        ac: 5,
        on: 4,
        of: 3,
        mt: 5,
        sl: 2,
        sw: 2,
        sa: 3,
        sg: 4,
        tl: 4,
        tw: 2,
        ta: 3,
        tg: 4
    },
    {
        id: 17,
        name: "Sport Bike",
        type: "kart",
        img: "SportBikeBodyMK8.png",
        wg: 1,
        ac: 2,
        on: 1,
        of: 2,
        mt: 3,
        sl: 4,
        sw: 3,
        sa: 3,
        sg: 3,
        tl: 3,
        tw: 3,
        ta: 2,
        tg: 3
    },
    {
        id: 18,
        name: "The Duke",
        type: "kart",
        img: "TheDukeBodyMK8.png",
        wg: 2,
        ac: 4,
        on: 3,
        of: 3,
        mt: 4,
        sl: 3,
        sw: 3,
        sa: 3,
        sg: 3,
        tl: 3,
        tw: 2,
        ta: 3,
        tg: 3
    },
    {
        id: 19,
        name: "Flame Rider",
        type: "kart",
        img: "FlameRiderBodyMK8.png",
        wg: 1,
        ac: 5,
        on: 3,
        of: 5,
        mt: 5,
        sl: 2,
        sw: 2,
        sa: 4,
        sg: 3,
        tl: 4,
        tw: 3,
        ta: 4,
        tg: 3
    },
    {
        id: 20,
        name: "Varmint",
        type: "kart",
        img: "VarmintBodyMK8.png",
        wg: 1,
        ac: 6,
        on: 3,
        of: 4,
        mt: 6,
        sl: 1,
        sw: 3,
        sa: 1,
        sg: 1,
        tl: 5,
        tw: 4,
        ta: 4,
        tg: 2
    },
    {
        id: 21,
        name: "Mr. Scooty",
        type: "kart",
        img: "MrScootyBodyMK8.png",
        wg: 0,
        ac: 7,
        on: 1,
        of: 4,
        mt: 7,
        sl: 0,
        sw: 1,
        sa: 2,
        sg: 1,
        tl: 5,
        tw: 4,
        ta: 5,
        tg: 4
    },
    {
        id: 22,
        name: "Jet Bike",
        type: "kart",
        img: "JetBikeBodyMK8.png",
        wg: 1,
        ac: 2,
        on: 1,
        of: 2,
        mt: 3,
        sl: 4,
        sw: 3,
        sa: 3,
        sg: 3,
        tl: 3,
        tw: 3,
        ta: 2,
        tg: 3
    },
    {
        id: 23,
        name: "Yoshi Bike",
        type: "kart",
        img: "YoshiBikeBodyMK8.png",
        wg: 2,
        ac: 5,
        on: 4,
        of: 3,
        mt: 5,
        sl: 2,
        sw: 2,
        sa: 3,
        sg: 4,
        tl: 4,
        tw: 2,
        ta: 3,
        tg: 4
    },
    {
        id: 24,
        name: "Standard ATV",
        type: "kart",
        img: "StandardATVBodyMK8.png",
        wg: 4,
        ac: 0,
        on: 2,
        of: 5,
        mt: 0,
        sl: 5,
        sw: 2,
        sa: 3,
        sg: 1,
        tl: 0,
        tw: 1,
        ta: 1,
        tg: 0
    },
    {
        id: 25,
        name: "Wild Wiggler",
        type: "kart",
        img: "WildWigglerBodyMK8.png",
        wg: 1,
        ac: 5,
        on: 3,
        of: 5,
        mt: 5,
        sl: 2,
        sw: 2,
        sa: 4,
        sg: 3,
        tl: 4,
        tw: 3,
        ta: 4,
        tg: 3
    },
    {
        id: 26,
        name: "Teddy Buggy",
        type: "kart",
        img: "TeddyBuggyBodyMK8.png",
        wg: 2,
        ac: 5,
        on: 4,
        of: 3,
        mt: 5,
        sl: 2,
        sw: 2,
        sa: 3,
        sg: 4,
        tl: 4,
        tw: 2,
        ta: 3,
        tg: 4
    },
    {
        id: 27,
        name: "GLA",
        type: "kart",
        img: "GLA-MK8.png",
        wg: 4,
        ac: 0,
        on: 2,
        of: 5,
        mt: 0,
        sl: 5,
        sw: 2,
        sa: 3,
        sg: 1,
        tl: 0,
        tw: 1,
        ta: 1,
        tg: 0
    },
    {
        id: 28,
        name: "W 25 Silver Arrow",
        type: "kart",
        img: "W25SilverArrow-MK8.png",
        wg: 1,
        ac: 5,
        on: 3,
        of: 5,
        mt: 5,
        sl: 2,
        sw: 2,
        sa: 4,
        sg: 3,
        tl: 4,
        tw: 3,
        ta: 4,
        tg: 3
    },
    {
        id: 29,
        name: "300 SL Roadster",
        type: "kart",
        img: "300SLRoadster_MK8.png",
        wg: 2,
        ac: 4,
        on: 3,
        of: 3,
        mt: 4,
        sl: 3,
        sw: 3,
        sa: 3,
        sg: 3,
        tl: 3,
        tw: 2,
        ta: 3,
        tg: 3
    },
    {
        id: 30,
        name: "Blue Falcon",
        type: "kart",
        img: "MK8BlueFalcon.png",
        wg: 0,
        ac: 3,
        on: 1,
        of: 3,
        mt: 3,
        sl: 4,
        sw: 2,
        sa: 4,
        sg: 3,
        tl: 2,
        tw: 3,
        ta: 5,
        tg: 1
    },
    {
        id: 31,
        name: "Tanooki Kart",
        type: "kart",
        img: "MK8_Tanooki_Buggy_Sprite.png",
        wg: 3,
        ac: 2,
        on: 4,
        of: 7,
        mt: 3,
        sl: 2,
        sw: 4,
        sa: 3,
        sg: 3,
        tl: 4,
        tw: 4,
        ta: 3,
        tg: 3
    },
    {
        id: 32,
        name: "B Dasher",
        type: "kart",
        img: "ZeldaMK8Bdasher.png",
        wg: 3,
        ac: 1,
        on: 3,
        of: 1,
        mt: 1,
        sl: 5,
        sw: 1,
        sa: 4,
        sg: 2,
        tl: 1,
        tw: 1,
        ta: 2,
        tg: 0
    },
    {
        id: 33,
        name: "Master Cycle",
        type: "kart",
        img: "MK8MasterCycle.png",
        wg: 2,
        ac: 2,
        on: 1,
        of: 0,
        mt: 3,
        sl: 4,
        sw: 2,
        sa: 3,
        sg: 3,
        tl: 3,
        tw: 2,
        ta: 3,
        tg: 2
    },
    {
        id: 34,
        name: "Streetle",
        type: "kart",
        img: "MK8Streetle.png",
        wg: 0,
        ac: 6,
        on: 0,
        of: 6,
        mt: 6,
        sl: 1,
        sw: 5,
        sa: 0,
        sg: 2,
        tl: 4,
        tw: 5,
        ta: 2,
        tg: 3
    },
    {
        id: 35,
        name: "P-Wing",
        type: "kart",
        img: "MK8PWing.png",
        wg: 3,
        ac: 1,
        on: 3,
        of: 1,
        mt: 1,
        sl: 5,
        sw: 1,
        sa: 4,
        sg: 2,
        tl: 1,
        tw: 1,
        ta: 2,
        tg: 0
    },
    {
        id: 36,
        name: "City Tripper",
        type: "kart",
        img: "MK8_Light-Green_City_Tripper.png",
        wg: 1,
        ac: 6,
        on: 3,
        of: 4,
        mt: 6,
        sl: 1,
        sw: 3,
        sa: 1,
        sg: 1,
        tl: 5,
        tw: 4,
        ta: 4,
        tg: 2
    },
    {
        id: 37,
        name: "Bone Rattler",
        type: "kart",
        img: "MK8BoneRattler.png",
        wg: 4,
        ac: 1,
        on: 1,
        of: 3,
        mt: 2,
        sl: 4,
        sw: 5,
        sa: 2,
        sg: 0,
        tl: 1,
        tw: 5,
        ta: 1,
        tg: 1
    },
    {
        id: 38,
        name: "Koopa Clown",
        type: "kart",
        img: "MK8DX_Koopa_Clown.png",
        wg: 3,
        ac: 2,
        on: 4,
        of: 7,
        mt: 3,
        sl: 2,
        sw: 4,
        sa: 3,
        sg: 3,
        tl: 4,
        tw: 4,
        ta: 3,
        tg: 3
    },
    {
        id: 39,
        name: "Splat Buggy",
        type: "kart",
        img: "MK8DX_Splat_Buggy.png",
        wg: 0,
        ac: 3,
        on: 1,
        of: 3,
        mt: 3,
        sl: 4,
        sw: 2,
        sa: 4,
        sg: 3,
        tl: 3,
        tw: 3,
        ta: 5,
        tg: 1
    },
    {
        id: 40,
        name: "Inkstriker",
        type: "kart",
        img: "MK8DX_Inkstriker.png",
        wg: 3,
        ac: 3,
        on: 2,
        of: 4,
        mt: 4,
        sl: 3,
        sw: 3,
        sa: 5,
        sg: 4,
        tl: 2,
        tw: 2,
        ta: 4,
        tg: 2
    },
    {
        id: 41,
        name: "Mario",
        type: "driver",
        img: "MK8_Mario_Icon.png",
        wg: 6,
        ac: 2,
        on: 4,
        of: 2,
        mt: 2,
        sl: 6,
        sw: 6,
        sa: 6,
        sg: 6,
        tl: 4,
        tw: 4,
        ta: 4,
        tg: 4
    },
    {
        id: 42,
        name: "Luigi",
        type: "driver",
        img: "MK8_Luigi_Icon.png",
        wg: 6,
        ac: 2,
        on: 5,
        of: 1,
        mt: 2,
        sl: 6,
        sw: 6,
        sa: 6,
        sg: 6,
        tl: 5,
        tw: 5,
        ta: 5,
        tg: 5
    },
    {
        id: 43,
        name: "Peach",
        type: "driver",
        img: "MK8_Peach_Icon.png",
        wg: 4,
        ac: 3,
        on: 3,
        of: 3,
        mt: 3,
        sl: 5,
        sw: 5,
        sa: 5,
        sg: 5,
        tl: 5,
        tw: 5,
        ta: 5,
        tg: 5
    },
    {
        id: 44,
        name: "Daisy",
        type: "driver",
        img: "MK8_Daisy_Icon.png",
        wg: 4,
        ac: 3,
        on: 3,
        of: 3,
        mt: 3,
        sl: 5,
        sw: 5,
        sa: 5,
        sg: 5,
        tl: 5,
        tw: 5,
        ta: 5,
        tg: 5
    },
    {
        id: 45,
        name: "Yoshi",
        type: "driver",
        img: "MK8_Yoshi_Icon.png",
        wg: 4,
        ac: 3,
        on: 3,
        of: 3,
        mt: 3,
        sl: 5,
        sw: 5,
        sa: 5,
        sg: 5,
        tl: 5,
        tw: 5,
        ta: 5,
        tg: 5
    },
    {
        id: 46,
        name: "Toad",
        type: "driver",
        img: "MK8_Toad_Icon.png",
        wg: 3,
        ac: 4,
        on: 3,
        of: 4,
        mt: 3,
        sl: 3,
        sw: 3,
        sa: 3,
        sg: 3,
        tl: 7,
        tw: 7,
        ta: 7,
        tg: 7
    },
    {
        id: 47,
        name: "Toadette",
        type: "driver",
        img: "MK8_Toadette_Icon.png",
        wg: 2,
        ac: 5,
        on: 4,
        of: 2,
        mt: 4,
        sl: 2,
        sw: 2,
        sa: 2,
        sg: 2,
        tl: 7,
        tw: 7,
        ta: 7,
        tg: 7
    },
    {
        id: 48,
        name: "Koopa Troopa",
        type: "driver",
        img: "MK8_Koopa_Icon.png",
        wg: 2,
        ac: 4,
        on: 1,
        of: 5,
        mt: 4,
        sl: 2,
        sw: 2,
        sa: 2,
        sg: 2,
        tl: 8,
        tw: 8,
        ta: 8,
        tg: 8
    },
    {
        id: 49,
        name: "Bowser",
        type: "driver",
        img: "MK8_Bowser_Icon.png",
        wg: 10,
        ac: 0,
        on: 6,
        of: 0,
        mt: 0,
        sl: 10,
        sw: 10,
        sa: 10,
        sg: 10,
        tl: 0,
        tw: 0,
        ta: 0,
        tg: 0
    },
    {
        id: 50,
        name: "Donkey Kong",
        type: "driver",
        img: "MK8_DKong_Icon.png",
        wg: 8,
        ac: 1,
        on: 10,
        of: 0,
        mt: 1,
        sl: 9,
        sw: 9,
        sa: 9,
        sg: 9,
        tl: 2,
        tw: 2,
        ta: 2,
        tg: 2
    },
    {
        id: 51,
        name: "Wario",
        type: "driver",
        img: "MK8_Wario_Icon.png",
        wg: 9,
        ac: 0,
        on: 5,
        of: 1,
        mt: 0,
        sl: 10,
        sw: 10,
        sa: 10,
        sg: 10,
        tl: 1,
        tw: 1,
        ta: 1,
        tg: 1
    },
    {
        id: 52,
        name: "Waluigi",
        type: "driver",
        img: "MK8_Waluigi_Icon.png",
        wg: 8,
        ac: 1,
        on: 10,
        of: 0,
        mt: 1,
        sl: 9,
        sw: 9,
        sa: 9,
        sg: 9,
        tl: 2,
        tw: 2,
        ta: 2,
        tg: 2
    },
    {
        id: 53,
        name: "Rosalina",
        type: "driver",
        img: "MK8_Rosalina_Icon.png",
        wg: 7,
        ac: 1,
        on: 9,
        of: 3,
        mt: 2,
        sl: 7,
        sw: 7,
        sa: 7,
        sg: 7,
        tl: 3,
        tw: 3,
        ta: 3,
        tg: 3
    },
    {
        id: 54,
        name: "Metal Mario",
        type: "driver",
        img: "MK8_MMario_Icon.png",
        wg: 10,
        ac: 1,
        on: 8,
        of: 1,
        mt: 1,
        sl: 8,
        sw: 8,
        sa: 8,
        sg: 8,
        tl: 3,
        tw: 3,
        ta: 3,
        tg: 3
    },
    {
        id: 55,
        name: "Pink Gold Peach",
        type: "driver",
        img: "MK8_PGPeach_Icon.png",
        wg: 10,
        ac: 1,
        on: 8,
        of: 1,
        mt: 1,
        sl: 8,
        sw: 8,
        sa: 8,
        sg: 8,
        tl: 3,
        tw: 3,
        ta: 3,
        tg: 3
    },
    {
        id: 56,
        name: "Lakitu",
        type: "driver",
        img: "MK8_Lakitu_Icon.png",
        wg: 2,
        ac: 4,
        on: 1,
        of: 5,
        mt: 4,
        sl: 2,
        sw: 2,
        sa: 2,
        sg: 2,
        tl: 8,
        tw: 8,
        ta: 8,
        tg: 8
    },
    {
        id: 57,
        name: "Shy Guy",
        type: "driver",
        img: "MK8_ShyGuy_Icon.png",
        wg: 3,
        ac: 4,
        on: 3,
        of: 4,
        mt: 3,
        sl: 3,
        sw: 3,
        sa: 3,
        sg: 3,
        tl: 7,
        tw: 7,
        ta: 7,
        tg: 7
    },
    {
        id: 58,
        name: "Baby Mario",
        type: "driver",
        img: "MK8_BabyMario_Icon.png",
        wg: 1,
        ac: 5,
        on: 2,
        of: 4,
        mt: 4,
        sl: 1,
        sw: 1,
        sa: 1,
        sg: 1,
        tl: 8,
        tw: 8,
        ta: 8,
        tg: 8
    },
    {
        id: 59,
        name: "Baby Luigi",
        type: "driver",
        img: "MK8_BabyLuigi_Icon.png",
        wg: 1,
        ac: 5,
        on: 2,
        of: 4,
        mt: 4,
        sl: 1,
        sw: 1,
        sa: 1,
        sg: 1,
        tl: 8,
        tw: 8,
        ta: 8,
        tg: 8
    },
    {
        id: 60,
        name: "Baby Peach",
        type: "driver",
        img: "MK8_BabyPeach_Icon.png",
        wg: 0,
        ac: 4,
        on: 3,
        of: 5,
        mt: 5,
        sl: 0,
        sw: 0,
        sa: 0,
        sg: 0,
        tl: 10,
        tw: 10,
        ta: 10,
        tg: 10
    },
    {
        id: 61,
        name: "Baby Daisy",
        type: "driver",
        img: "MK8_BabyDaisy_Icon.png",
        wg: 0,
        ac: 4,
        on: 3,
        of: 5,
        mt: 5,
        sl: 0,
        sw: 0,
        sa: 0,
        sg: 0,
        tl: 10,
        tw: 10,
        ta: 10,
        tg: 10
    },
    {
        id: 62,
        name: "Baby Rosalina",
        type: "driver",
        img: "MK8_BabyRosalina_Icon.png",
        wg: 0,
        ac: 5,
        on: 4,
        of: 3,
        mt: 5,
        sl: 0,
        sw: 0,
        sa: 0,
        sg: 0,
        tl: 9,
        tw: 9,
        ta: 9,
        tg: 9
    },
    {
        id: 63,
        name: "Larry",
        type: "driver",
        img: "MK8_Larry_Icon.png",
        wg: 3,
        ac: 4,
        on: 3,
        of: 4,
        mt: 3,
        sl: 3,
        sw: 3,
        sa: 3,
        sg: 3,
        tl: 7,
        tw: 7,
        ta: 7,
        tg: 7
    },
    {
        id: 64,
        name: "Lemmy",
        type: "driver",
        img: "MK8_Lemmy_Icon.png",
        wg: 0,
        ac: 5,
        on: 4,
        of: 3,
        mt: 5,
        sl: 0,
        sw: 0,
        sa: 0,
        sg: 0,
        tl: 9,
        tw: 9,
        ta: 9,
        tg: 9
    },
    {
        id: 65,
        name: "Wendy",
        type: "driver",
        img: "MK8_Wendy_Icon.png",
        wg: 2,
        ac: 5,
        on: 4,
        of: 2,
        mt: 4,
        sl: 2,
        sw: 2,
        sa: 2,
        sg: 2,
        tl: 7,
        tw: 7,
        ta: 7,
        tg: 7
    },
    {
        id: 66,
        name: "Ludwig",
        type: "driver",
        img: "MK8_Ludwig_Icon.png",
        wg: 6,
        ac: 2,
        on: 4,
        of: 2,
        mt: 2,
        sl: 6,
        sw: 6,
        sa: 6,
        sg: 6,
        tl: 4,
        tw: 4,
        ta: 4,
        tg: 4
    },
    {
        id: 67,
        name: "Iggy",
        type: "driver",
        img: "MK8_Iggy_Icon.png",
        wg: 6,
        ac: 2,
        on: 5,
        of: 1,
        mt: 2,
        sl: 6,
        sw: 6,
        sa: 6,
        sg: 6,
        tl: 5,
        tw: 5,
        ta: 5,
        tg: 5
    },
    {
        id: 68,
        name: "Roy",
        type: "driver",
        img: "MK8_Roy_Icon.png",
        wg: 8,
        ac: 1,
        on: 10,
        of: 0,
        mt: 1,
        sl: 9,
        sw: 9,
        sa: 9,
        sg: 9,
        tl: 2,
        tw: 2,
        ta: 2,
        tg: 2
    },
    {
        id: 69,
        name: "Morton",
        type: "driver",
        img: "MK8_Morton_Icon.png",
        wg: 10,
        ac: 0,
        on: 6,
        of: 0,
        mt: 0,
        sl: 10,
        sw: 10,
        sa: 10,
        sg: 10,
        tl: 0,
        tw: 0,
        ta: 0,
        tg: 0
    },
    {
        id: 70,
        name: "Mii",
        type: "driver",
        img: "ActuallyMii200.png",
        wg: 6,
        ac: 2,
        on: 4,
        of: 2,
        mt: 2,
        sl: 6,
        sw: 6,
        sa: 6,
        sg: 6,
        tl: 4,
        tw: 4,
        ta: 4,
        tg: 4
    },
    {
        id: 71,
        name: "Tanooki Mario",
        type: "driver",
        img: "MK8_Tanooki_Mario_Icon.png",
        wg: 5,
        ac: 3,
        on: 7,
        of: 1,
        mt: 3,
        sl: 5,
        sw: 5,
        sa: 5,
        sg: 5,
        tl: 5,
        tw: 5,
        ta: 5,
        tg: 5
    },
    {
        id: 72,
        name: "Link",
        type: "driver",
        img: "MK8_Link_Icon.png",
        wg: 7,
        ac: 1,
        on: 9,
        of: 3,
        mt: 2,
        sl: 7,
        sw: 7,
        sa: 7,
        sg: 7,
        tl: 3,
        tw: 3,
        ta: 3,
        tg: 3
    },
    {
        id: 73,
        name: "Villager (male)",
        type: "driver",
        img: "VillagerMale-Icon-MK8.png",
        wg: 5,
        ac: 3,
        on: 7,
        of: 1,
        mt: 3,
        sl: 5,
        sw: 5,
        sa: 5,
        sg: 5,
        tl: 5,
        tw: 5,
        ta: 5,
        tg: 5
    },
    {
        id: 74,
        name: "Isabelle",
        type: "driver",
        img: "MK8_Isabelle_Icon.png",
        wg: 2,
        ac: 5,
        on: 4,
        of: 2,
        mt: 4,
        sl: 2,
        sw: 2,
        sa: 2,
        sg: 2,
        tl: 7,
        tw: 7,
        ta: 7,
        tg: 7
    },
    {
        id: 75,
        name: "Cat Peach",
        type: "driver",
        img: "MK8_Cat_Peach_Icon.png",
        wg: 3,
        ac: 4,
        on: 2,
        of: 3,
        mt: 3,
        sl: 4,
        sw: 4,
        sa: 4,
        sg: 4,
        tl: 6,
        tw: 6,
        ta: 6,
        tg: 6
    },
    {
        id: 76,
        name: "Dry Bowser",
        type: "driver",
        img: "MK8_Dry_Bowser_Icon.png",
        wg: 9,
        ac: 0,
        on: 5,
        of: 1,
        mt: 0,
        sl: 10,
        sw: 10,
        sa: 10,
        sg: 10,
        tl: 1,
        tw: 1,
        ta: 1,
        tg: 1
    },
    {
        id: 77,
        name: "Villager (female)",
        type: "driver",
        img: "VillagerFemale-Icon-MK8.png",
        wg: 3,
        ac: 3,
        on: 2,
        of: 4,
        mt: 4,
        sl: 3,
        sw: 3,
        sa: 5,
        sg: 4,
        tl: 2,
        tw: 2,
        ta: 4,
        tg: 2
    },
    {
        id: 78,
        name: "Gold Mario",
        type: "driver",
        img: "MK8DX_Gold_Mario_Icon.png",
        wg: 10,
        ac: 1,
        on: 8,
        of: 1,
        mt: 1,
        sl: 8,
        sw: 8,
        sa: 8,
        sg: 8,
        tl: 3,
        tw: 3,
        ta: 3,
        tg: 3
    },
    {
        id: 79,
        name: "Dry Bones",
        type: "driver",
        img: "MK8DX_Dry_Bones_Icon.png",
        wg: 1,
        ac: 5,
        on: 2,
        of: 4,
        mt: 4,
        sl: 1,
        sw: 1,
        sa: 1,
        sg: 1,
        tl: 8,
        tw: 8,
        ta: 8,
        tg: 8
    },
    {
        id: 80,
        name: "Bowser Jr.",
        type: "driver",
        img: "MK8_Bowser_Jr_Icon.png",
        wg: 2,
        ac: 4,
        on: 1,
        of: 5,
        mt: 4,
        sl: 2,
        sw: 2,
        sa: 2,
        sg: 2,
        tl: 8,
        tw: 8,
        ta: 8,
        tg: 8
    },
    {
        id: 81,
        name: "King Boo",
        type: "driver",
        img: "MK8DX_King_Boo_Icon.png",
        wg: 7,
        ac: 1,
        on: 9,
        of: 3,
        mt: 2,
        sl: 7,
        sw: 7,
        sa: 7,
        sg: 7,
        tl: 3,
        tw: 3,
        ta: 3,
        tg: 3
    },
    {
        id: 82,
        name: "Inkling Girl",
        type: "driver",
        img: "MK8DX_Female_Inkling_Icon.png",
        wg: 3,
        ac: 4,
        on: 2,
        of: 3,
        mt: 3,
        sl: 4,
        sw: 4,
        sa: 4,
        sg: 4,
        tl: 6,
        tw: 6,
        ta: 6,
        tg: 6
    },
    {
        id: 83,
        name: "Inkling Boy",
        type: "driver",
        img: "MK8DX_Male_Inkling_Icon.png",
        wg: 5,
        ac: 3,
        on: 7,
        of: 1,
        mt: 3,
        sl: 5,
        sw: 5,
        sa: 5,
        sg: 5,
        tl: 5,
        tw: 5,
        ta: 5,
        tg: 5
    },
    {
        id: 84,
        name: "Standard",
        type: "tire",
        img: "StandardTiresMK8.png",
        wg: 2,
        ac: 4,
        on: 2,
        of: 5,
        mt: 3,
        sl: 2,
        sw: 3,
        sa: 2,
        sg: 3,
        tl: 3,
        tw: 3,
        ta: 3,
        tg: 3
    },
    {
        id: 85,
        name: "Monster",
        type: "tire",
        img: "MonsterTiresMK8.png",
        wg: 4,
        ac: 2,
        on: 3,
        of: 7,
        mt: 2,
        sl: 2,
        sw: 2,
        sa: 2,
        sg: 1,
        tl: 0,
        tw: 1,
        ta: 0,
        tg: 1
    },
    {
        id: 86,
        name: "Roller",
        type: "tire",
        img: "RollerTiresMK8.png",
        wg: 0,
        ac: 6,
        on: 0,
        of: 4,
        mt: 6,
        sl: 0,
        sw: 3,
        sa: 0,
        sg: 3,
        tl: 4,
        tw: 4,
        ta: 4,
        tg: 4
    },
    {
        id: 87,
        name: "Slim",
        type: "tire",
        img: "SlimTiresMK8.png",
        wg: 2,
        ac: 2,
        on: 4,
        of: 1,
        mt: 2,
        sl: 3,
        sw: 2,
        sa: 4,
        sg: 2,
        tl: 4,
        tw: 4,
        ta: 3,
        tg: 4
    },
    {
        id: 88,
        name: "Slick",
        type: "tire",
        img: "SlickTiresMK8.png",
        wg: 3,
        ac: 1,
        on: 4,
        of: 0,
        mt: 0,
        sl: 4,
        sw: 0,
        sa: 4,
        sg: 0,
        tl: 2,
        tw: 0,
        ta: 2,
        tg: 1
    },
    {
        id: 89,
        name: "Metal",
        type: "tire",
        img: "MetalTiresMK8.png",
        wg: 4,
        ac: 0,
        on: 1,
        of: 2,
        mt: 0,
        sl: 4,
        sw: 3,
        sa: 1,
        sg: 2,
        tl: 2,
        tw: 2,
        ta: 1,
        tg: 0
    },
    {
        id: 90,
        name: "Button",
        type: "tire",
        img: "ButtonTiresMK8.png",
        wg: 0,
        ac: 5,
        on: 1,
        of: 3,
        mt: 5,
        sl: 1,
        sw: 2,
        sa: 2,
        sg: 2,
        tl: 3,
        tw: 3,
        ta: 4,
        tg: 2
    },
    {
        id: 91,
        name: "Off-Road",
        type: "tire",
        img: "Off-Road.png",
        wg: 3,
        ac: 3,
        on: 3,
        of: 6,
        mt: 1,
        sl: 3,
        sw: 4,
        sa: 2,
        sg: 1,
        tl: 1,
        tw: 1,
        ta: 2,
        tg: 2
    },
    {
        id: 92,
        name: "Sponge",
        type: "tire",
        img: "SpongeTiresMK8.png",
        wg: 1,
        ac: 4,
        on: 2,
        of: 6,
        mt: 4,
        sl: 1,
        sw: 1,
        sa: 1,
        sg: 4,
        tl: 2,
        tw: 1,
        ta: 2,
        tg: 3
    },
    {
        id: 93,
        name: "Wood",
        type: "tire",
        img: "WoodTiresMK8.png",
        wg: 2,
        ac: 2,
        on: 4,
        of: 1,
        mt: 2,
        sl: 3,
        sw: 2,
        sa: 4,
        sg: 2,
        tl: 4,
        tw: 4,
        ta: 3,
        tg: 4
    },
    {
        id: 94,
        name: "Cushion",
        type: "tire",
        img: "CushionTiresMK8.png",
        wg: 1,
        ac: 4,
        on: 2,
        of: 6,
        mt: 4,
        sl: 1,
        sw: 1,
        sa: 1,
        sg: 4,
        tl: 2,
        tw: 1,
        ta: 2,
        tg: 3
    },
    {
        id: 95,
        name: "Blue Standard",
        type: "tire",
        img: "Blue_Standard.png",
        wg: 2,
        ac: 4,
        on: 2,
        of: 5,
        mt: 3,
        sl: 2,
        sw: 3,
        sa: 2,
        sg: 3,
        tl: 3,
        tw: 3,
        ta: 3,
        tg: 3
    },
    {
        id: 96,
        name: "Hot Monster",
        type: "tire",
        img: "HotMonsterTiresMK8.png",
        wg: 4,
        ac: 2,
        on: 3,
        of: 7,
        mt: 2,
        sl: 2,
        sw: 2,
        sa: 2,
        sg: 1,
        tl: 0,
        tw: 1,
        ta: 0,
        tg: 1
    },
    {
        id: 97,
        name: "Azure Roller",
        type: "tire",
        img: "AzureRollerTiresMK8.png",
        wg: 0,
        ac: 6,
        on: 0,
        of: 4,
        mt: 6,
        sl: 0,
        sw: 3,
        sa: 0,
        sg: 3,
        tl: 4,
        tw: 4,
        ta: 4,
        tg: 4
    },
    {
        id: 98,
        name: "Crimson Slim",
        type: "tire",
        img: "CrimsonSlimTiresMK8.png",
        wg: 2,
        ac: 2,
        on: 4,
        of: 1,
        mt: 2,
        sl: 3,
        sw: 2,
        sa: 4,
        sg: 2,
        tl: 4,
        tw: 4,
        ta: 3,
        tg: 4
    },
    {
        id: 99,
        name: "Cyber Slick",
        type: "tire",
        img: "CyberSlickTiresMK8.png",
        wg: 3,
        ac: 1,
        on: 4,
        of: 0,
        mt: 0,
        sl: 4,
        sw: 0,
        sa: 4,
        sg: 0,
        tl: 2,
        tw: 0,
        ta: 2,
        tg: 1
    },
    {
        id: 100,
        name: "Retro Off-Road",
        type: "tire",
        img: "Retro_Off-Road.png",
        wg: 3,
        ac: 3,
        on: 3,
        of: 6,
        mt: 1,
        sl: 3,
        sw: 4,
        sa: 2,
        sg: 1,
        tl: 1,
        tw: 1,
        ta: 2,
        tg: 2
    },
    {
        id: 101,
        name: "Gold Tires",
        type: "tire",
        img: "Gold_Tires_MK8.png",
        wg: 4,
        ac: 0,
        on: 1,
        of: 2,
        mt: 0,
        sl: 4,
        sw: 3,
        sa: 1,
        sg: 2,
        tl: 2,
        tw: 2,
        ta: 1,
        tg: 0
    },
    {
        id: 102,
        name: "GLA Tires",
        type: "tire",
        img: "GLATires-MK8.png",
        wg: 2,
        ac: 4,
        on: 2,
        of: 5,
        mt: 3,
        sl: 2,
        sw: 3,
        sa: 2,
        sg: 3,
        tl: 3,
        tw: 3,
        ta: 3,
        tg: 3
    },
    {
        id: 103,
        name: "Triforce Tires",
        type: "tire",
        img: "MK8-TriforceTires.png",
        wg: 3,
        ac: 3,
        on: 3,
        of: 6,
        mt: 1,
        sl: 3,
        sw: 4,
        sa: 2,
        sg: 1,
        tl: 1,
        tw: 1,
        ta: 2,
        tg: 2
    },
    {
        id: 104,
        name: "Leaf Tires",
        type: "tire",
        img: "Leaf_Tires_MK8.png",
        wg: 0,
        ac: 5,
        on: 1,
        of: 3,
        mt: 5,
        sl: 1,
        sw: 2,
        sa: 2,
        sg: 2,
        tl: 3,
        tw: 3,
        ta: 4,
        tg: 2
    },
    {
        id: 105,
        name: "Super Glider",
        type: "glider",
        img: "SuperGliderMK8.png",
        wg: 1,
        ac: 1,
        on: 1,
        of: 1,
        mt: 1,
        sl: 1,
        sw: 1,
        sa: 0,
        sg: 2,
        tl: 1,
        tw: 0,
        ta: 1,
        tg: 1
    },
    {
        id: 106,
        name: "Cloud Glider",
        type: "glider",
        img: "Cloud_Glider.png",
        wg: 0,
        ac: 2,
        on: 1,
        of: 1,
        mt: 2,
        sl: 0,
        sw: 1,
        sa: 1,
        sg: 1,
        tl: 1,
        tw: 0,
        ta: 1,
        tg: 2
    },
    {
        id: 107,
        name: "Wario Wing",
        type: "glider",
        img: "WarioWingMK8.png",
        wg: 2,
        ac: 1,
        on: 2,
        of: 0,
        mt: 1,
        sl: 1,
        sw: 0,
        sa: 1,
        sg: 2,
        tl: 1,
        tw: 1,
        ta: 0,
        tg: 1
    },
    {
        id: 108,
        name: "Waddle Wing",
        type: "glider",
        img: "WaddleWingMK8.png",
        wg: 1,
        ac: 1,
        on: 1,
        of: 1,
        mt: 1,
        sl: 1,
        sw: 1,
        sa: 0,
        sg: 2,
        tl: 1,
        tw: 0,
        ta: 1,
        tg: 1
    },
    {
        id: 109,
        name: "Peach Parasol",
        type: "glider",
        img: "PeachParasolGliderMK8.png",
        wg: 1,
        ac: 2,
        on: 2,
        of: 0,
        mt: 2,
        sl: 0,
        sw: 0,
        sa: 1,
        sg: 1,
        tl: 1,
        tw: 1,
        ta: 0,
        tg: 2
    },
    {
        id: 110,
        name: "Parachute",
        type: "glider",
        img: "ParachuteGliderMK8.png",
        wg: 0,
        ac: 2,
        on: 1,
        of: 1,
        mt: 2,
        sl: 0,
        sw: 1,
        sa: 1,
        sg: 1,
        tl: 1,
        tw: 0,
        ta: 1,
        tg: 2
    },
    {
        id: 111,
        name: "Parafoil",
        type: "glider",
        img: "ParafoilGliderMK8.png",
        wg: 1,
        ac: 2,
        on: 2,
        of: 0,
        mt: 2,
        sl: 0,
        sw: 0,
        sa: 1,
        sg: 1,
        tl: 1,
        tw: 1,
        ta: 0,
        tg: 2
    },
    {
        id: 112,
        name: "Flower Glider",
        type: "glider",
        img: "FlowerGliderMK8.png",
        wg: 0,
        ac: 2,
        on: 1,
        of: 1,
        mt: 2,
        sl: 0,
        sw: 1,
        sa: 1,
        sg: 1,
        tl: 1,
        tw: 0,
        ta: 1,
        tg: 2
    },
    {
        id: 113,
        name: "Bowser Kite",
        type: "glider",
        img: "BowserKiteMK8.png",
        wg: 1,
        ac: 2,
        on: 2,
        of: 0,
        mt: 2,
        sl: 0,
        sw: 0,
        sa: 1,
        sg: 1,
        tl: 1,
        tw: 1,
        ta: 0,
        tg: 2
    },
    {
        id: 114,
        name: "Plane Glider",
        type: "glider",
        img: "PlaneGliderMK8.png",
        wg: 2,
        ac: 1,
        on: 2,
        of: 0,
        mt: 1,
        sl: 1,
        sw: 0,
        sa: 1,
        sg: 2,
        tl: 1,
        tw: 1,
        ta: 0,
        tg: 1
    },
    {
        id: 115,
        name: "MKTV Parafoil",
        type: "glider",
        img: "MKTVParafoilGliderMK8.png",
        wg: 1,
        ac: 2,
        on: 2,
        of: 0,
        mt: 2,
        sl: 0,
        sw: 0,
        sa: 1,
        sg: 1,
        tl: 1,
        tw: 1,
        ta: 0,
        tg: 2
    },
    {
        id: 116,
        name: "Gold Glider",
        type: "glider",
        img: "GoldGliderMK8.png",
        wg: 2,
        ac: 1,
        on: 2,
        of: 0,
        mt: 1,
        sl: 1,
        sw: 0,
        sa: 1,
        sg: 2,
        tl: 1,
        tw: 1,
        ta: 0,
        tg: 1
    },
    {
        id: 117,
        name: "Hylian Kite",
        type: "glider",
        img: "MK8-HylianKite.png",
        wg: 1,
        ac: 1,
        on: 1,
        of: 1,
        mt: 1,
        sl: 1,
        sw: 1,
        sa: 0,
        sg: 2,
        tl: 1,
        tw: 0,
        ta: 1,
        tg: 1
    },
    {
        id: 118,
        name: "Paper Glider",
        type: "glider",
        img: "PaperGliderIcon-MK8.png",
        wg: 0,
        ac: 2,
        on: 1,
        of: 1,
        mt: 2,
        sl: 0,
        sw: 1,
        sa: 1,
        sg: 1,
        tl: 1,
        tw: 0,
        ta: 1,
        tg: 2
    }
]

export default data